import { Getter } from 'vuex';
import StepsState from '@/types/store/StepsState';
import RootState from '@/types/store/RootState';

export type stepByIdFn = (id: string) => any;
const stepById: Getter<StepsState, RootState> = (state) => (id: string) => state[id];

export default stepById;
